// users

const getters = {
	getUsers(state) {
		return state.users;
	},
	getUser(state) {
		return state.user;
	},
	getRoles(state) {
		return state.roles;
	},
	getTeams(state) {
		return state.teams;
	},

};

export default getters;